import { useCallback, useMemo } from 'react';

import { useGrid } from '@Components/Grid';

import { useDataExtractorStore } from '../../store';

export default function useEvents() {
  const { store: { downloadFile, deleteFile }, handleRefresh } = useGrid()
  const { cancelProcess, retryProcess } = useDataExtractorStore()

  const handleDownload = useCallback(async id => {
    const data = await downloadFile(id)
    const href = URL.createObjectURL(data)

    const link = document.createElement('a')
    link.href = href
    link.setAttribute('download', `${id}.zip`)
    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link)
    URL.revokeObjectURL(href)
  }, [downloadFile])

  const handleDelete = useCallback(async jobId => {
    await deleteFile(jobId)
    handleRefresh()
  }, [deleteFile, handleRefresh])

  const handleCancel = useCallback(async id => {
    await cancelProcess(id)
    handleRefresh()
  }, [cancelProcess, handleRefresh])

  const handleRetry = useCallback(async id => {
    await retryProcess(id)
    handleRefresh()
  }, [retryProcess, handleRefresh])

  return useMemo(() => ({
    handleRetry,
    handleDownload,
    handleDelete,
    handleCancel,
  }), [handleDownload, handleDelete, handleCancel, handleRetry])
}
